define('root/Assets/Templates/Html/Menu/Js/Module/scrollStateHandler',[
	'jquery',
	'project/MbiConfig',
	'base/MbiHelper',
	'base/MbiBrowser',
	'base/Vendor/rAF',
	'base/Vendor/Debounce'
], function(
	$,
	mbiConfig,
	_
) {
	'use strict';

	var module = {

		lastPosition: 0,
		documentHeight: null,
		windowHeight: null,
		isZero: false,
		isEnd: null,
		zeroBreakpoint: 0,
		endBreakpoint: 500,
		scrollMagic: false,

		browserContext: 'general',
		checkSelector: null,
		checkSelectorObject: null,

		init: function() {

			if(mbiConfig.browser.browserName == 'chrome' || mbiConfig.browser.browserName == 'safari' || mbiConfig.browser.browserName == 'opera' ) {
				module.browserContext = 'webkit';
				module.checkSelector = 'body';
			} else if (mbiConfig.browser.browserName == 'firefox') {
				module.browserContext = 'firefox';
				module.checkSelector = window;
			} else {
				
				module.checkSelector = 'body, html';
			}
			if (mbiConfig.browser.browserName == 'chrome') {
				module.checkSelector = window;
			}
			module.checkSelectorObject = $(module.checkSelector);

			module.refresh();

			var loop = function() {

				requestAnimationFrame(loop);

				//var check = $(module.checkSelector).scrollTop();
				var check = module.checkSelectorObject.scrollTop();

				if(module.lastPosition !== check) {

					module.lastPosition = check;

					module.topHandler();
					module.bottomHandler();

				}
				
				

			}
			loop();

			$(window).resize($.debounce(500, function() {
				module.refresh();
			}));

		},
		topHandler: function() {

			if(module.lastPosition <= module.zeroBreakpoint) {
				module.isZero = true;
				$('body.is_scrolled').removeClass('is_scrolled');
				$(document).trigger('scrollTop');
			} else {
				module.isZero = false;
				$('body:not(.is_scrolled)').addClass('is_scrolled');
				if (module.scrollMagic) {
					module.scrollMagic = false;
					if (!$('body').hasClass('scrolled')) {

						$('body').trigger('scrolled');
					}
				}

			}

		},
		bottomHandler: function() {

			if(module.lastPosition+module.windowHeight >= module.documentHeight-module.endBreakpoint/* && module.isEnd === false*/) {
				module.isEnd = true;
				$(document).trigger('scrollBottom');
			} else if(module.lastPosition+module.windowHeight < module.documentHeight-module.endBreakpoint/* && module.isEnd === true*/) {
				module.isEnd = false;
			}

		},
		refresh: function() {
			module.windowHeight = $(window).height();
			module.documentHeight = $(document).height();
			module.endBreakpoint = module.windowHeight * 0.5;
			 module.lastPosition = $(module.checkSelector).scrollTop();
			
			//module.lastPosition = module.checkSelectorObject.scrollTop();
			if (module.lastPosition == 0) {

				module.scrollMagic = true;

			} else {
				
				$('body:not(.scrolled)').addClass('scrolled');
				$('body').addClass('started');
			}

			module.topHandler();
			module.bottomHandler();

		}

	};

	if(_.exists('.js_scroll')) {
		module.init();
	}

	return module;

});
